import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutRoutingModule } from './checkout-routing.module';
import { CheckoutComponent } from './checkout/checkout.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MomentModule } from 'ngx-moment';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { FormsModule } from '@angular/forms';
import { SessioncheckoutComponent } from './sessioncheckout/sessioncheckout.component';
import { ClubsponsorshipcheckoutComponent } from './clubsponsorshipcheckout/clubsponsorshipcheckout.component';
import { BuyticketcheckoutComponent } from './buyticketcheckout/buyticketcheckout.component';


@NgModule({
  declarations: [CheckoutComponent, SessioncheckoutComponent, ClubsponsorshipcheckoutComponent, BuyticketcheckoutComponent],
  imports: [
    CommonModule,
    CheckoutRoutingModule,
    SharedModule,
    MomentModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    FormsModule
   
  ]
})
export class CheckoutModule { }
